export const en = {
    "RU": "Russia",
    "KZ": "Kazakhstan",
    "BY": "Belarus",
    "UZ": "Uzbekistan",
    "AZ": "Azerbaijan",
    "DZ": "Algeria",
    "BH": "Bahrain",
    "DJ": "Djibouti",
    "EG": "Egypt",
    "IQ": "Iraq",
    "JO": "Jordan",
    "KW": "Kuwait",
    "LB": "Lebanon",
    "LY": "Libya",
    "MA": "Morocco",
    "OM": "Oman",
    "QA": "Qatar",
    "SA": "Saudi Arabia",
    "SY": "Syria",
    "TN": "Tunisia",
    "AE": "United Arab Emirates",
    "PS": "Palestine",
    "YE": "Yemen",
    "MT": "Malta",
    "IL": "Israel",
    "IR": "Iran",
} as const;
export const ru = {
    "RU": "Россия",
    "KZ": "Казахстан",
    "BY": "Беларусь",
    "UZ": "Узбекистан",
    "AZ": "Азербайджан",
    "DZ": "Алжир",
    "BH": "Бахрейн",
    "DJ": "Джибути",
    "EG": "Египет",
    "IQ": "Ирак",
    "JO": "Иордания",
    "KW": "Кувейт",
    "LB": "Ливан",
    "LY": "Ливия",
    "MA": "Марокко",
    "OM": "Оман",
    "QA": "Катар",
    "SA": "Саудовская Аравия",
    "SY": "Сирия",
    "TN": "Тунис",
    "AE": "Объединенные Арабские Эмираты",
    "PS": "Палестина",
    "YE": "Йемен",
    "MT": "Мальта",
    "IL": "Израиль",
    "IR": "Иран",
} as const;
